module.exports = __webpack_public_path__ + "static/media/photography-honor.2a031cae.svg";